import React from "react";
import Chart from "react-google-charts";
import { ScaleLoader } from "react-spinners";
import { defaultColors } from "../HelperFiles/Constants";

export default function DoriStackedBarChart(props) {
  const {
    chartEvents,
    barChartData,
    title,
    chartColors,
    width = '85%'
  } = props;

  // console.log('chart events: ', chartEvents, barChartData);

  return (
    <div >
      <Chart
        chartEvents={chartEvents}
        height="100%"
        chartType={"ColumnChart"}
        loader={
          <div
            style={{
              justifyContent: "center",
              marginTop: "99px",
            }}
          >
            <ScaleLoader
              height={50}
              width={5}
              radius={7}
              margin={3}
              color={"#d12e26"}
            />
          </div>
        }
        data={
          barChartData && barChartData.length !== 0
            ? barChartData
            : [["Date", "Events"], ["No Events Found", 0]]
        }
        options={{
          title: title,
          chartArea: { width },
          legend: { position: "none" },
          // vAxis: options.vAxis ? options.vAxis : null,
          // hAxis: options.hAxis ? options.hAxis : null,
          // seriesType: "bars",
          isStacked: true,
          fontName: "Lato, sans-serif",
          colors: chartColors || defaultColors,
        }}
      // rootProps={{ "data-testid": "2" }}
      />
    </div>
  );
}